export class LearnizRequirementTree {
  chapters: LearnizChapterRequirement[];

  constructor(learnizChapterRequirement?: LearnizRequirementTree) {
    if (learnizChapterRequirement) {
      this.chapters = (learnizChapterRequirement.chapters || []).map(c => new LearnizChapterRequirement(null, c));
    } else {
      this.chapters = [];
    }
  }
}

export abstract class LearnizElemLocked {
  elementsLocked: ElemLocked[];
  elementsLocker: ElemLocker[];

  protected constructor(elementsLocked: ElemLocked[], elementsLocker: ElemLocker[]) {
    this.elementsLocked = (elementsLocked || []).map(e => e);
    this.elementsLocker = (elementsLocker || []).map(e => e);
  }
}

export class LearnizChapterRequirement extends LearnizElemLocked {
  slug: string;
  slides: LearnizSlideRequirement[];

  constructor(slug?: string, learnizChapterRequirement?: LearnizChapterRequirement) {
    if (!learnizChapterRequirement) {
      learnizChapterRequirement = {} as any;
    }
    super(learnizChapterRequirement.elementsLocked, learnizChapterRequirement.elementsLocker);
    this.slides = (learnizChapterRequirement.slides || []).map(s => new LearnizSlideRequirement(null, s));
    this.slug = slug || learnizChapterRequirement.slug || '';
  }
}

export class LearnizSlideRequirement extends LearnizElemLocked {
  interactivities: LearnizInteractivityRequirement[];
  slug: string;

  constructor(slug?: string, learnizSlideRequirement?: LearnizSlideRequirement) {
    if (!learnizSlideRequirement) {
      learnizSlideRequirement = {} as any;
    }
    super(learnizSlideRequirement.elementsLocked, learnizSlideRequirement.elementsLocker);
    this.interactivities = (learnizSlideRequirement.interactivities || []).map(
      i => new LearnizInteractivityRequirement(null, i),
    );
    this.slug = slug || learnizSlideRequirement.slug || '';
  }
}

export class LearnizInteractivityRequirement extends LearnizElemLocked {
  slug: string;

  constructor(slug?: string, learnizInteractivityRequirement?: LearnizInteractivityRequirement) {
    if (!learnizInteractivityRequirement) {
      learnizInteractivityRequirement = {} as any;
    }
    super(learnizInteractivityRequirement.elementsLocked, learnizInteractivityRequirement.elementsLocker);
    this.slug = slug || learnizInteractivityRequirement.slug || '';
  }
}

export class ElemLocked {
  chapterSlug: string;
  slideSlug?: string;
}

export class ElemLocker {
  chapterSlug: string;
  slideSlug?: string;
  interactivitySlug: string;
}
